module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div",
    class: _vm.headerFix()
  }, [_c('header', {
    staticClass: "gheader",
    class: _vm.noShadow()
  }, [(_vm.isStaging) ? _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("テスト環境 ")]) : _c('h1', {
    staticClass: "gheader__logo"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/logo.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "gheader__menu-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_menu.png"),
      "alt": "メニュー"
    },
    on: {
      "click": _vm.menuChange
    }
  })]), _c('div', {
    staticClass: "gheader__referral-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_friend.png"),
      "alt": "友達紹介"
    },
    on: {
      "click": function($event) {
        _vm.goReferral()
      }
    }
  })]), _c('div', {
    staticClass: "gheader__info-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_info.png"),
      "alt": "お知らせ"
    },
    on: {
      "click": _vm.infoChange
    }
  }), (_vm.infoCount > 0) ? _c('span', {
    staticClass: "gheader__info-icon__num"
  }, [_vm._v(_vm._s(_vm.infoCount))]) : _vm._e()]), _c('div', {
    staticClass: "gheader__info-body",
    class: _vm.openInfo()
  }, [_c('div', {
    staticClass: "gheader__info-body__inner"
  }, [(_vm.infoCount > 0) ? _c('h3', {
    staticClass: "gheader__info-body__title"
  }, [_vm._v("あなたへのお知らせ")]) : _c('h3', {
    staticClass: "gheader__info-body__title"
  }, [_vm._v("お知らせはありません")]), _c('ul', {
    staticClass: "gheader__info-body__list"
  }, [(_vm.existRequestHolidayNotice) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goRequestHolidayNew
    }
  }, [_vm._v("希望休暇を提出してください。")])]) : _vm._e(), (_vm.isStepUpCallExist) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goStepUpCallList
    }
  }, [_vm._v("まだ研修評価回答が完了していないスタッフがいます。回答を促してください。")])]) : _vm._e(), (_vm.isEvaluateCallExist) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goEvaluateCallList
    }
  }, [_vm._v("まだ人事評価回答が完了していないスタッフがいます。回答を促してください。")])]) : _vm._e(), (_vm.getTargetmoralCount > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMoralStart
    }
  }, [_vm._v("今月のモラルチェックがまだのようです。※回答期限" + _vm._s(_vm.getTargetmoralEnddate) + "まで")])]) : _vm._e(), (_vm.isShopMaster && _vm.getNoanswermoralCount > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMoralNoAnswerList
    }
  }, [_vm._v("まだモラルチェックが完了していないスタッフがいます。回答を促してください。")])]) : _vm._e(), (_vm.isUnReadEsMyCardExist) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goESMyCardMyList
    }
  }, [_vm._v("あなたへの未読カードがあります。")])]) : _vm._e(), (_vm.getRejectedCount) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goProposeRejectedList
    }
  }, [_vm._v("提案に返事が届きました。")])]) : _vm._e(), (_vm.isSystemManagement && _vm.getUnapprovedProposeCount > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goFrontUrl('/#/propose_unapproved_list')
      }
    }
  }, [_vm._v("承認前の提案があります。")])]) : _vm._e(), (_vm.getMessageCount) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMessageList
    }
  }, [_vm._v("未読のメッセージがあります。")])]) : _vm._e(), _vm._l((_vm.getShiftNotices), function(shiftNotice) {
    return (_vm.getShiftNoticeCount) ? _c('li', {
      staticClass: "menu-link"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goShiftDetail(shiftNotice.shift_date)
        }
      }
    }, [_vm._v(_vm._s(_vm.getShiftDateString(shiftNotice.shift_date)) + "のシフトが変更されました。")])]) : _vm._e()
  }), (_vm.existWillMustNotice) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goWillMustEdit
    }
  }, [_vm._v("MUST・WILLの提出期間になりました。")])]) : _vm._e(), (_vm.existProposeApprovedNotice > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goProposeAllshopList
    }
  }, [_vm._v("提案が承認されました。")])]) : _vm._e(), (_vm.existProposeAdoptedNotice > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goProposeAdoptList
    }
  }, [_vm._v("提案が採用されました。")])]) : _vm._e(), (_vm.isUnreadCompanyNoticeExist) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goCompanyNoticeList
    }
  }, [_vm._v("未読の全社通達があります。")])]) : _vm._e(), (_vm.stockShopmasterNoticeExist) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goShopmasterNotice
    }
  }, [_vm._v("在庫発注の承認依頼があります。")])]) : _vm._e(), (_vm.isShopMaster && _vm.noanswerServiceQuestionCount > 0) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goServiceAnswerCallList
    }
  }, [_vm._v("まだ接客評価が完了していないスタッフがいます。回答を促してください。")])]) : _vm._e(), (_vm.targetServiceQuestionCount > 0 || this.ownServiceQuestion) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goServiceQuestionAnswer
    }
  }, [_vm._v("今月の接客評価がまだのようです。月末までに回答してください。")])]) : _vm._e()], 2)])]), (_vm.isExistSafetyConfirmation && !_vm.isTrainingSafetyConfirmation) ? _c('div', {
    staticClass: "gheader__safety-confirmation-icon-warning"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_safety_confirmation_warning.png"),
      "alt": "安否確認"
    },
    on: {
      "click": _vm.goSafetyConfirmation
    }
  })]) : (_vm.isExistSafetyConfirmation && _vm.isTrainingSafetyConfirmation) ? _c('div', {
    staticClass: "gheader__safety-confirmation-icon-training"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_safety_confirmation_training.png"),
      "alt": "安否確認"
    },
    on: {
      "click": _vm.goSafetyConfirmation
    }
  })]) : _c('div', {
    staticClass: "gheader__safety-confirmation-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_safety_confirmation.png"),
      "alt": "安否確認"
    },
    on: {
      "click": _vm.goSafetyConfirmation
    }
  })]), _c('nav', {
    staticClass: "gheader__menu-body",
    class: _vm.openMenu()
  }, [_c('div', {
    staticClass: "gheader__menu-body__head menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goProfile
    }
  }, [(_vm.profileImagePath) ? _c('div', {
    staticClass: "gheader__menu-body__head__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.profileImagePath + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "gheader__menu-body__head__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "gheader__menu-body__head__txt"
  }, [_c('p', {
    staticClass: "fz17"
  }, [_vm._v(_vm._s(_vm.getUserFullName)), _c('span', {
    staticClass: "fz13"
  }, [_vm._v("さん")])]), _c('p', {
    staticClass: "fz12"
  }, [_vm._v("プロフィールを確認・編集する")])])])]), _c('ul', {
    staticClass: "gheader__menu-body__list"
  }, [_c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.onClickOmoiModalShow
    }
  }, [_vm._v("社内SNSを作った想い")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goProposeAllshopList
    }
  }, [_vm._v("提案！タイラのアイディア帳")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goShiftList
    }
  }, [_vm._v("シフトを確認する")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goEsMyCard
    }
  }, [_vm._v("ESmyカード一覧")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMagagineList
    }
  }, [_vm._v("社内報一覧")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMoral
    }
  }, [_vm._v("毎月のモラルチェック！")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goWillMust
    }
  }, [_vm._v("MUST・WILL一覧")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.checkVideoTerms
    }
  }, [_vm._v("教育マニュアル・研修動画を見る")])]), (_vm.userTypesQuestion) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goStepUpQuestionCheck('normal')
      }
    }
  }, [_vm._v("ステップアップ研修の評価項目を確認する")])]) : _vm._e(), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goTreatmentSalaryList
    }
  }, [_vm._v("待遇・制度の一覧を見る")])]), (!_vm.isShopMaster) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMessageSendManager
    }
  }, [_vm._v("店舗長へメッセージを送る")])]) : _vm._e(), (!_vm.isOfficer) ? _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goMessageSendOfficer
    }
  }, [_vm._v("相談・SOSメッセージを送る")])]) : _vm._e(), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goCompanyNoticeList
    }
  }, [_vm._v("全社通達一覧を確認する")])]), _c('li', {
    staticClass: "menu-link"
  }, [_c('a', {
    on: {
      "click": _vm.goChangePassword
    }
  }, [_vm._v("パスワードを変更する")])]), _c('li', {
    staticClass: "menu-link",
    staticStyle: {
      "margin-bottom": "63px"
    }
  }, [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("ログアウトする")])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "omoiModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#omoiModal"
    }
  }, [_vm._v("モーダル発火用")]), _vm._m(0), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "videoTermsModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#videoTermsModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "videoTermsModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(1), _vm._m(2), _c('button', {
    staticClass: "btn02 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.goVideoCategories
    }
  }, [_c('span', [_vm._v("同意して閲覧する")])]), _vm._m(3)])]), (_vm.isShowSafetyConfirmation) ? _c('div', {
    staticClass: "safety-confirmation-modal",
    attrs: {
      "id": "safetyConfirmationModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg05",
    staticStyle: {
      "margin": "80px 0px 0px"
    }
  }, [(_vm.isTrainingSafetyConfirmation) ? _c('h3', {
    staticClass: "heading_01 mb25 txt__caution"
  }, [_vm._v("こちらは訓練です!")]) : _vm._e(), _c('div', {
    staticClass: "modal__close__wrap moral-going__modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSafetyConfirmation
    }
  }, [_c('img', {
    staticClass: "modal__close",
    attrs: {
      "src": require("../images/icon_close_05.png"),
      "alt": "閉じる",
      "width": "24",
      "height": "24"
    }
  })]), _vm._m(4)]), _c('button', {
    staticClass: "btn btn-danger btn-block btn-lg safety-confirmation-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.goSafetyConfirmation
    }
  }, [_c('span', [_vm._v("報告する")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "omoiModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("熱い想いがあって"), _c('br'), _vm._v("社内SNS"), _c('br'), _vm._v("“WONDER WORLD”を"), _c('br'), _vm._v("作ったんだニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("みんな、いつもありがとう！"), _c('br'), _vm._v("お疲れ様ですニャン！")]), _c('p', [_vm._v("タイラニャンは、「タイラベストビート」を、より素敵な会社にしたいんだニャン！")]), _c('p', [_vm._v("そのためには、やっぱりみんなの声をきくのが一番！")]), _c('p', [_vm._v("お客様は勿論、会社のみんなにも、「居心地のいい、素敵な会社だ」と思ってもらえるように、がんばりたいんだニャン♪")]), _c('p', [_vm._v("“WONDER WORLD”、気軽に使ってほしいニャン♪")])]), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("閉じる")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb25 txt__caution"
  }, [_vm._v("社外秘！"), _c('br'), _vm._v("SNS投稿・複製"), _c('br'), _vm._v("厳禁！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("秘密の研修なので、"), _c('br'), _c('span', {
    staticClass: "txt__caution"
  }, [_vm._v("流出厳禁")]), _vm._v("なんだニャン！")]), _c('p', [_vm._v("（※転写・複製等行った場合には、\n著作物の侵害として法律にのっとり対処するほか、損害賠償の請求も行います）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__close__wrap moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('img', {
    staticClass: "modal__close",
    attrs: {
      "src": require("../images/icon_close_05.png"),
      "alt": "閉じる",
      "width": "24",
      "height": "24"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01"
  }, [_c('img', {
    attrs: {
      "src": require("../images/warning_mark.png")
    }
  }), _c('p', {
    staticClass: "help-modal-safety-cofnrimation-message"
  }, [_c('span', [_vm._v("以下のボタンより")])]), _c('p', {
    staticClass: "help-modal-safety-cofnrimation-message"
  }, [_c('strong', [_vm._v("安否報告")]), _c('span', [_vm._v("をしてください")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd48647e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-header.pug
// module id = 1444
// module chunks = 1